import './IncomingCallBar.css';

/**
 * Ringing banner for an inbound leg the coach has to decide on.
 *
 * Queue calls carry auto_answer and are accepted without ever reaching this bar — anything
 * else (a direct dial to this client identity, a transfer) rings here until answered or
 * rejected, or until Twilio's <Dial timeout> cancels the leg.
 */
export default function IncomingCallBar({ phoneNumber, onAnswer, onReject }) {
  return (
    <div className="incoming-call-bar" role="alert" aria-live="assertive">
      <div className="incoming-call-bar-main">
        <div className="incoming-call-bar-info">
          <span className="incoming-call-bar-pulse" aria-hidden="true" />
          <span className="incoming-call-bar-label">Incoming call</span>
          {phoneNumber && (
            <span className="incoming-call-bar-number">{phoneNumber}</span>
          )}
        </div>

        <div className="incoming-call-bar-controls">
          <button className="icb-btn icb-btn-answer" onClick={onAnswer}>
            Answer
          </button>
          <button className="icb-btn icb-btn-reject" onClick={onReject}>
            Reject
          </button>
        </div>
      </div>
    </div>
  );
}
